<template>
    <enter-code-screen
                        id="enterCodeLogin"
                        ref="enterCode"
                        v-model="code"
                        :help-text="helpTextCode"
                        :title="title"
                        :nextButtonDisabled="isLoading"
                        @next="verifySms"
                        @back="back"
    ><p v-html="text" />
        <a class="link" @click="goToLogin">{{changeText}}</a></enter-code-screen>

</template>

<script>
    import EnterCodeScreen from "../../components/layout/enterCode-screen";
    import Profile from '../../helpers/profile'
    import {
        verifySms as apiVerifySms,
        getApiErrorMessage,
        registerProfile as apiRegisterProfile,
        sendSecondOtpCode,
        sendThirdOtpCode
    } from '../../helpers/api'

    export default {
        name: "enterCodePage",
        components: {EnterCodeScreen},
        data() {
            return {
                code: Profile.thirdOTP.username ? Profile.thirdOTP.otpcode : (Profile.secondOTP.username ? Profile.secondOTP.otpcode : Profile.otpcode),
                helpTextCode: '',
                title: '',
                changeText: '',
                text: '',
                isLoading: false,
                isSecondOtp: !!Profile.secondOTP.username,
                isThirdOtp: !!Profile.thirdOTP.username,
            }
        },
        mounted: function () {
            let username = Profile.process === "accessRecovery" ? Profile.recoveryContacts[Profile.recoveryMethod] : Profile.username;
            if (this.isThirdOtp) {
                username = Profile.thirdOTP.username;
                this.title = this.$ml.get('sendCodeTitleMail');
                this.changeText = this.$ml.get('sendCodeChangeMail');
                this.text = this.$ml.get('sendCodeTextMail')+'<strong>'+username.trim()+'</strong>'
            } else if (this.isSecondOtp) {
                username = Profile.secondOTP.username;
                if (Profile.secondOTP.otptype === 'sms') {
                    this.title = this.$ml.get('sendCodeTitlePhone');
                    this.changeText = this.$ml.get('sendCodeChangePhone');
                    this.text = this.$ml.get('sendCodeTextPhone')+'<strong>'+username.trim()+'</strong>'
                } else {
                    this.title = this.$ml.get('sendCodeTitleMail');
                    this.changeText = this.$ml.get('sendCodeChangeMail');
                    this.text = this.$ml.get('sendCodeTextMail')+'<strong>'+username.trim()+'</strong>'
                }
            } else if (Profile.otptype === 'sms') {
                this.title = this.$ml.get('sendCodeTitlePhone');
                this.changeText = (Profile.process === 'accessRecovery') ? this.$ml.get('accessRecoveryChangePhone') : this.$ml.get('sendCodeChangePhone');
                this.text = this.$ml.get('sendCodeTextPhone')+'<strong>'+username.trim()+'</strong>'
            } else {
                this.title = this.$ml.get('sendCodeTitleMail');
                this.changeText = (Profile.process === 'accessRecovery') ? this.$ml.get('accessRecoveryChangeEmail') : this.$ml.get('sendCodeChangeMail');
                this.text = this.$ml.get('sendCodeTextMail')+'<strong>'+username.trim()+'</strong>'
            }
        },
        methods: {
            verifySms: function (code) {                        
                if (this.isLoading)
                    return;
                if (this.isThirdOtp)
                    this.verifyThirdOtp(code);
                else if (this.isSecondOtp)
                    this.verifySecondOtp(code);
                else {
                    this.isLoading = true;
                    this.$loader.show();
                    apiVerifySms(code).then(data => {      
                        if (Profile.registration) {
                            if (Profile.otptype === 'email')
                                this.$router.push('/registration/enterPhonePage');
                            else
                                this.$router.push({name: 'RegistrationStart'});
                        } else if (Profile.process === 'accessRecovery') {
                            if (Profile.needsetphone || Profile.needsetemail)
                                this.$router.push('/accessRecovery/infoSetAdditionalParams');
                            else
                                this.$router.push('/accessRecovery/infoPinCode');
                        } else if (!Profile.needsetpincode)
                            this.$router.push('/login/enterPinCode');
                        else if (!Profile.needsetquestion)
                            this.$router.push('/login/enterSecretQuestion');
                        else if (Profile.needsetphone || Profile.needsetpincode || Profile.needsetquestion)
                            this.$router.push('/login/infoSetAdditionalParams');
                        else
                            this.$router.push({name: 'LoginEnterPinCode'});
                    }, err => {
                        if (err.status === 428 && Profile.registration)
                            this.$router.push('/registration/enterPhonePage');
                        else
                            this.$refs.enterCode.showError(getApiErrorMessage(err, {
                                '401': this.$ml.get('sendCodeErrorWrong')
                            }));
                    }).finally(() => {
                        this.isLoading = false;
                        this.$loader.hide();
                    });
                }
            },

            verifySecondOtp: function (code) {
                if (this.isLoading)
                    return;
                Profile.secondOTP.otpcode = code;
                if (Profile.registration && Profile.otptype !== 'email')
                    this.register();
                else {
                    this.isLoading = true;
                    sendSecondOtpCode().then(() => {
                        if (Profile.process === 'accessRecovery') {
                            if (Profile.needsetemail)
                                this.$router.push('/accessRecovery/enterEmailPage');
                            else
                                this.$router.push('/accessRecovery/infoPinCode');
                        } else
                            this.$router.push({name: 'RegistrationStart'});
                    }, err => {
                        if (err.status === 428 && Profile.process == 'login') {
                            if (Profile.needsetpincode)
                                this.$router.push('/login/infoPinCode');
                            else if (Profile.needsetquestion)
                                this.$router.push('/login/infoSecretQuestion');
                        } else
                            this.$refs.enterCode.showError(getApiErrorMessage(err, {
                                '401': this.$ml.get('sendCodeErrorWrong')
                            }));
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
            },

            verifyThirdOtp: function (code) {
                if (this.isLoading)
                    return;
                Profile.thirdOTP.otpcode = code;
                this.isLoading = true;
                sendThirdOtpCode().then(() => {
                    this.$router.push('/accessRecovery/infoPinCode');
                }, err => {
                    this.$refs.enterCode.showError(getApiErrorMessage(err, {
                        '401': this.$ml.get('sendCodeErrorWrong')
                    }));
                }).finally(() => {
                    this.isLoading = false;
                });
            },

            register: function () {
                if (this.isLoading)
                    return;
                this.isLoading = true;
                apiRegisterProfile(true, Profile.secondOTP.otpcode).then(() => {
                    this.$router.push({name: 'RegistrationFinish'});
                }, err => {
                    this.$refs.enterCode.showError(getApiErrorMessage(err, {
                        '401': this.$ml.get('sendCodeErrorWrong'),
                        '406': this.$ml.get('errorUserAlreadyExist')
                    }));
                }).finally(() => {
                    this.isLoading = false;
                });
            },

            goToLogin: function () {
                let isMobile = window.innerWidth < 600;
                if (Profile.thirdOTP.username) {
                    Profile.thirdOTP.username = '';
                    Profile.thirdOTP.otpcode = '';
                    this.$router.go(isMobile ? -2 : -1);
                } else if (Profile.secondOTP.username) {
                    Profile.secondOTP.username = '';
                    Profile.secondOTP.otpcode = '';
                    this.$router.go(isMobile ? -2 : -1);
                } else {
                    Profile.username = '';
                    Profile.otpcode = '';
                    this.$router.push({name: 'LoginEnterLogin'});
                }
            },
            back: function () {
                let isMobile = window.innerWidth < 600;
                if (Profile.thirdOTP.username) {
                    Profile.thirdOTP.username = '';
                    Profile.thirdOTP.otpcode = '';
                } else if (Profile.secondOTP.username) {
                    Profile.secondOTP.username = '';
                    Profile.secondOTP.otpcode = '';
                } else {
                    Profile.username = '';
                    Profile.otpcode = '';
                }
                this.$router.go(isMobile ? -2 : -1);
            }
        },
    }
</script>

<style scoped>

</style>